import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type Tone = 'default' | 'warning' | 'success' | 'danger' | 'info';

const VALUE_TONES: Record<Tone, string> = {
  default: '',
  warning: 'text-warning-foreground',
  success: 'text-status-delivered-foreground',
  danger: 'text-overdue-foreground',
  info: 'text-status-qualified-foreground',
};

/** Indicator card: label, large value, hint line. */
export function KpiCard({ label, value, hint, tone = 'default' }: { label: string; value: ReactNode; hint?: ReactNode; tone?: Tone }) {
  return (
    <div className="flex flex-col gap-1.5 rounded-card border border-border bg-card px-5 py-[18px]">
      <span className="text-[13px] text-muted-foreground">{label}</span>
      <span className={cn('text-[30px] font-bold leading-none', VALUE_TONES[tone])}>{value}</span>
      {hint !== undefined && (
        <span className={cn('text-xs', tone === 'warning' ? 'text-warning-foreground' : tone === 'danger' ? 'text-overdue-foreground' : 'text-muted-foreground')}>{hint}</span>
      )}
    </div>
  );
}

export function KpiGrid({ children }: { children: ReactNode }) {
  return <div className="grid gap-4 [grid-template-columns:repeat(auto-fit,minmax(220px,1fr))]">{children}</div>;
}
